export default __webpack_public_path__ + "static/media/civisAlert.7e3b4cec.wav";